import styled from "@emotion/styled";
import tw from "twin.macro";

export const DescriptionList = styled("dl")(tw`grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2`);
export const DescriptionTerm = styled("div")(tw`space-y-1`);
export const DescriptionTermLabel = styled("dt")(tw`text-sm font-medium text-gray-500`);
export const DescriptionTermValue = styled("dd")(tw`text-sm text-gray-900`);
